define("shared/components/shared/ui/video", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _computed, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (has-block)}}
    <video
      controls={{this.controls}}
      onerror={{action (optional @handleError)}}
      preload={{if this.isSafari "auto" this.preload}}
      ...attributes
    >
      {{yield (hash reloadVideo=this.reloadVideo)}}
    </video>
  {{else}}
    <video
      controls={{this.controls}}
      onerror={{action (optional @handleError)}}
      preload={{if this.isSafari "auto" this.preload}}
      src={{@src}}
      ...attributes
    ></video>
  {{/if}}
  */
  {
    "id": "cgOONXwv",
    "block": "[[[41,[48,[30,4]],[[[1,\"  \"],[11,\"video\"],[16,\"controls\",[30,0,[\"controls\"]]],[16,\"onerror\",[28,[37,2],[[30,0],[28,[37,3],[[30,1]],null]],null]],[16,\"preload\",[52,[30,0,[\"isSafari\"]],\"auto\",[30,0,[\"preload\"]]]],[17,2],[12],[1,\"\\n    \"],[18,4,[[28,[37,5],null,[[\"reloadVideo\"],[[30,0,[\"reloadVideo\"]]]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[11,\"video\"],[16,\"controls\",[30,0,[\"controls\"]]],[16,\"onerror\",[28,[37,2],[[30,0],[28,[37,3],[[30,1]],null]],null]],[16,\"preload\",[52,[30,0,[\"isSafari\"]],\"auto\",[30,0,[\"preload\"]]]],[16,\"src\",[30,3]],[17,2],[12],[13],[1,\"\\n\"]],[]]]],[\"@handleError\",\"&attrs\",\"@src\",\"&default\"],false,[\"if\",\"has-block\",\"action\",\"optional\",\"yield\",\"hash\"]]",
    "moduleName": "shared/components/shared/ui/video.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::Ui::Video
   * @extends Component
   *
   * This component renders a video (<video ...>) tag.
   * By default, it sets the controls attribute to true and preload to metadata(auto for Safari browser)
   * It expects a @src argument for inline usage and <source> tag(at least 1) for block usage. Updates to src fields on source elements
   * do not trigger video re-rendering, so a reload video player function has been provided to use with the did-update modifier.
   *
   * Other valid HTML Attributes (id, class, width, height, data-*, etc.) are automatically added to the rendered <video ...> tag
   *
   * Inline Usage Arguments:
   * - src (String) The video source url
   * Example:
   * ```
   * <Shared::Ui::Video
   *  @src="https://somevalidurl.mp4"
   *  @preload="auto"
   *  class="o--media"
   *  data-test-id="test-video"/>
   * ```
   *
   * Block Usage example:
   * ```
   * <Shared::Ui::Video class="o--media" @preload="auto" alt="some text">
   *   <source src="https://somevalidurl.mp4" type="video/mp4">
   * </Shared::Ui::Video>
   * ```
   *
   * ```
   * <Shared::Ui::Video class="o--media" @preload="auto">
   *  <source src="https://somevalidurl.mp4" type="video/mp4">
   *  <source src="https://someothervalidurl.webm" type="video/webm">
   * </Shared::Ui::Video>
   * ```
   *
   * Named Block Usage example:
   *
   * ```
   * <Shared::Ui::Video class="o--media" @preload="auto" as |videoPlayer|>
   *   <source src="{{@mediaItem.videoUrl}}" type="video/mp4" {{did-update videoPlayer.reloadVideo @mediaItem}}>
   * </Shared::Ui::Video>
   * ```
   */
  let SharedUiVideoComponent = (_dec = (0, _computed.equal)('userAgent.browser.info.name', 'Safari'), (_class = class SharedUiVideoComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "userAgent", _descriptor, this);

      _initializerDefineProperty(this, "isSafari", _descriptor2, this);
    }

    get controls() {
      return this.args.controls ?? true;
    }

    get preload() {
      return this.args.preload ?? 'metadata';
    }

    reloadVideo() {
      const element = this.element.querySelector('video');
      element.load();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isSafari", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "reloadVideo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "reloadVideo"), _class.prototype)), _class));
  _exports.default = SharedUiVideoComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharedUiVideoComponent);
});